module.exports = __webpack_public_path__ + "static/posts-1-53ac73afc8e1af0a6c1e6516974dc0f6.jpg";